'use strict';

angular.module('app').directive('mapHeight', function($window, $timeout) {
    var link = function(scope, element) {


        var w = angular.element($window);

        scope.getWindowDimensions = function() {
            return w[0];
        };

        scope.$watch(scope.getWindowDimensions, function(newValue, oldValue) {
            $timeout(function() {
                var map = $('#' + scope.mapId);
                if (scope.widthResize) {
                    map.css({
                        'height': newValue.innerHeight * 0.9 + 'px',
                        width: newValue.innerWidth * scope.widthResize + 'px'
                    });
                } else {
                    map.css('height', newValue.innerHeight * 0.6 + 'px');
                }

                scope.refresh();
            }, 150);
        });

        w.bind('resize', function() {
            $timeout(function() {
                scope.$apply();
                scope.refresh();
            }, 200);
        });

    };
    return {
        restrict: 'A',
        replace: false,
        scope: {
            mapId: '@',
            refresh: '&',
            widthResize: '=',
            fancyboxResize: '='
        },
        link: link
    };
})